import { ApiClient } from "@/api-client/src/core/api-client";
import {
  GeneralSettingsResponse,
  healthApiResponse,
  PromotionalMessage,
  PromotionalMessagesResponse,
  StoreAddress,
  StoreAddressResponse,
} from "@/packages/types/general";

const apiClient = new ApiClient();
const webService = apiClient.web;

/**
 * Logs in the user with email and password.
 */
export const fetchGeneralSettings =
  async (): Promise<GeneralSettingsResponse> => {
    const response = await webService.get<GeneralSettingsResponse>(
      "/general-settings"
    );
    return response;
  };

// export const fetchGeneralSettings = async () => {
//   return await webService.getWithEtag<GeneralSettingsResponse>("/general-settings");
// };

export const fetchSiteFeatures = async (): Promise<PromotionalMessage[]> => {
  const response = await webService.get<PromotionalMessagesResponse>(
    "/promotional-messages"
  );
  return response.data;
};
export const fetchStoreSettings = async (): Promise<StoreAddress[]> => {
  const response = await webService.get<StoreAddressResponse>("/store-address");
  return response.data;
};
export const healthapi = async (): Promise<healthApiResponse> => {
  const response = await webService.get<healthApiResponse>("/health");
  return response;
};
